// Who answers for NCommerce in the privacy policy and the terms of use.
export const LEGAL_INFO = {
  company: 'BONOME SOFTWARE LIMITADA',
  cnpj: '45.244.107/0001-13',
  address: 'Rua Bolívia, Quadra 34, Lote 06, Jardim das Américas 1ª etapa, CEP 75.070-030, Anápolis – GO',
  privacyEmail: 'privacidade@ncommerce.app',
  contactEmail: 'contato@ncommerce.app',
  dpo: 'Ariel Aleksandrus Rosa Bonome',
  forum: 'Anápolis – GO',
  updatedAt: '02/11/2026',
  essentialPlanPrice: 'R$ 600,00',
  completePlanPrice: 'R$ 900,00',
};
